export const ADMINALBUMS = '/admin/album/album-list-admin'
export const ADMINALBUM = '/admin/album/album-admin/:id'
export const ALBUMUPDATE = '/admin/album/album-update/:id'
export const SELECTALBUMCATEGORY = '/admin/album/select-album-category'
